import React, { useEffect, useState } from "react";
import Footer from "../components/footer";
import NavBar from "../components/navbar";
import PocketBase from "pocketbase";
import Parser from "html-react-parser";

export default function Events() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [eventsList, setEventsList] = useState({ future: [], past: [] });
  const [loading, setLoading] = useState(true);
  const pb = new PocketBase("https://friendsofstandrewsstatepark.org");
  const today = new Date();
  today.setDate(today.getDate() - 1);
  today.setUTCHours(0, 0, 0, 0);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    (async () => {
      const futureEvents = await pb.collection("event").getFullList({
        sort: "event_time",
        fields: "id,event_title,event_time,event_description",
        filter: `event_time>='${today.toISOString()}'`,
      });
      const pastEvents = await pb.collection("event").getFullList({
        sort: "-event_time",
        fields: "id,event_title,event_time,event_description",
        filter: `event_time<'${today.toISOString()}'`,
      });
      setEventsList({ future: futureEvents, past: pastEvents });
      setLoading(false);
    })();
  }, []);

  const formatDate = (d) =>
    new Date(new Date(d).setHours(new Date(d).getHours() + 3)).toLocaleString(
      "en-US",
      {
        hour12: true,
        day: "numeric",
        month: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      },
    );

  const parseOptions = {
    replace(domNode) {
      if (domNode?.name !== "img" || !domNode.attribs) return undefined;
      return (
        <img
          {...domNode.attribs}
          alt={domNode.attribs.alt || "Event image"}
          loading="lazy"
        />
      );
    },
  };

  return (
    <div className="content d-flex flex-column w-100 h-100 justify-content-between fsa-body-bg events">
      <NavBar />
      <div className="d-flex flex-column flex-fill align-items-center justify-content-center px-3 pt-4 pb-5">
        <h2 className="fsa-section-title mt-3">Upcoming Events</h2>
        {loading ? (
          <p className="text-muted fst-italic">Loading...</p>
        ) : eventsList.future.length > 0 ? (
          eventsList.future.map((d) => (
            <div
              key={d.id}
              className="card d-flex flex-column fsa-page-card mb-3"
            >
              <div className="card-header fsa-card-header d-flex justify-content-between">
                <span className="fw-semibold">{d.event_title}</span>
                <span className="fsa-card-header-date">
                  {formatDate(d.event_time)}
                </span>
              </div>
              <div className="card-body">
                {Parser(d.event_description, parseOptions)}
              </div>
            </div>
          ))
        ) : (
          <p className="text-muted fst-italic">
            Nothing scheduled for the near future.
          </p>
        )}

        <h2 className="fsa-section-title mt-5">Past Events</h2>
        {loading ? (
          <p className="text-muted fst-italic">Loading...</p>
        ) : eventsList.past.length > 0 ? (
          eventsList.past.map((d) => (
            <div
              key={d.id}
              className="card d-flex flex-column fsa-page-card mb-3 fsa-past-event"
            >
              <div className="card-header fsa-card-header d-flex justify-content-between">
                <span className="fw-semibold">{d.event_title}</span>
                <span className="fsa-card-header-date">
                  {formatDate(d.event_time)}
                </span>
              </div>
              <div className="card-body">
                {Parser(d.event_description, parseOptions)}
              </div>
            </div>
          ))
        ) : (
          <p className="text-muted fst-italic">Nothing to look back upon.</p>
        )}
      </div>
      <Footer />
    </div>
  );
}
